import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M8.625 12.005a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0m0 0h-.375m5.25 0c0 4.556-4.03 8.25-9 8.25a9.8 9.8 0 0 1-2.555-.337 5.97 5.97 0 0 1-4.035 1.058 6 6 0 0 1-.474-.065 4.5 4.5 0 0 0 .978-2.026c.09-.457-.133-.9-.467-1.225C3.93 16.183 3 14.193 3 12.005c0-4.557 4.03-8.25 9-8.25s9 3.693 9 8.25"
    }, null, -1)
  ])))
}
export default { render: render }